import { FC, ReactElement } from 'react';

import classnames from 'classnames';

const SkeletonItem: FC<{
  classNames?: string;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  animated?: boolean;
}> = ({ classNames, rounded = 'none', animated = true }): ReactElement => {
  return (
    <div
      className={classnames(`tw-bg-raa-gray-3 tw-rounded-${rounded} ${classNames ?? ''}`, {
        'tw-animate-pulse': animated
      })}
    ></div>
  );
};

export default SkeletonItem;
